/**
 * Does a stretch of wall hold a run? The one predicate, in one place.
 *
 * A corner's body takes a cabinet DEPTH out of the wall it stands against,
 * whatever treatment the corner turns out to carry, and what is left has to
 * hold a real cabinet or the stretch is not a leg — it is the 3" filler this
 * whole change exists to refuse
 * (`claude-docs/2026-09-15-kitchen-segment-shapes-plan.md`).
 *
 * Its own module because both callers need it and neither may import the
 * other: `segmentGraph` reads the room's geometry and already imports
 * `cornerDetection`, while `cornerDetection` asks the same question of one
 * junction it has already measured.
 *
 * Neither number is new. 12" is `MIN_CABINET_WIDTH`, the narrowest cabinet the
 * classifier accepts as a run; 24" is the cabinet depth. Their sum is 36" —
 * `CORNER_CABINET_FOOTPRINT`, the L corner unit's leg, which is why a corner
 * with two long legs behaves exactly as it always has. What changes is that
 * the SHORT leg faces the same test (user ruling, 2026-09-26).
 */

const {
  KITCHEN_CABINET_DIMENSIONS,
  MIN_CABINET_WIDTH,
} = require('./constants');

/** What a corner body takes out of the wall it stands against. */
const CORNER_CLAIM = KITCHEN_CABINET_DIMENSIONS.depth;

/** Is a real cabinet left? `usableLength` is the stretch after its claims. */
function legHolds(usableLength) {
  return usableLength >= MIN_CABINET_WIDTH;
}

/**
 * The same question at a junction, where the claim has not been taken off yet.
 * `freeRun` is the unblocked wall measured FROM the junction — what
 * `analyzeWallAt` calls `freeRunFromCorner`, and what a segment's length is
 * when the segment starts at the vertex.
 */
function legHoldsAtCorner(freeRun) {
  return legHolds((freeRun || 0) - CORNER_CLAIM);
}

module.exports = { CORNER_CLAIM, legHolds, legHoldsAtCorner };
